import { render, staticRenderFns } from "./heard.vue?vue&type=template&id=335a404f&scoped=true&"
import script from "./heard.vue?vue&type=script&lang=js&"
export * from "./heard.vue?vue&type=script&lang=js&"
import style0 from "./heard.vue?vue&type=style&index=0&id=335a404f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335a404f",
  null
  
)

export default component.exports